import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button, Modal, Form } from "react-bootstrap";
import AdminHeader from "../../common/AdminHeader";
import Footer from "../../common/Footer";
import { baseUrl } from "../../../Utility/constants";

const SchoolSessionMapping = () => {
  const [mappings, setMappings] = useState([]);
  const [schools, setSchools] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    mappingId: 0,
    schoolId: "",
    sessionId: "",
  });
  const [editMode, setEditMode] = useState(false);

  useEffect(() => {
    fetchMappings();
    fetchSchools();
    fetchSessions();
  }, []);

  const fetchMappings = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/SchoolSessionMapping`);
      setMappings(response.data);
    } catch (error) {
      console.log("Error fetching school session mappings.");
    }
  };

  const fetchSchools = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/SchoolGeneralInfo`);
      setSchools(response.data);
    } catch (error) {
      console.log("Error fetching schools.");
    }
  };

  const fetchSessions = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/SessionMaster`);
      setSessions(response.data);
    } catch (error) {
      console.log("Error fetching sessions.");
    }
  };

  const handleShowModal = (
    mapping = { mappingId: 0, schoolId: "", sessionId: "" }
  ) => {
    setFormData(mapping);
    setEditMode(mapping.mappingId !== 0);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setFormData({ mappingId: 0, schoolId: "", sessionId: "" });
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    if (!formData.schoolId || !formData.sessionId) {
      toast.warning("Please select both School and Session.");
      return;
    }

    try {
      if (editMode) {
        await axios.put(
          `${baseUrl}/api/SchoolSessionMapping/${formData.mappingId}`,
          formData
        );
        toast.success("Mapping updated successfully.");
      } else {
        await axios.post(`${baseUrl}/api/SchoolSessionMapping`, formData);
        toast.success("Mapping added successfully.");
      }
      fetchMappings();
      handleCloseModal();
    } catch (error) {
      toast.error(error.response?.data || "An error occurred.");
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this mapping?")) {
      try {
        await axios.delete(`${baseUrl}/api/SchoolSessionMapping/${id}`);
        toast.success("Mapping deleted successfully.");
        fetchMappings();
      } catch (error) {
        toast.error("Error deleting mapping.");
      }
    }
  };

  return (
    <>
      <AdminHeader />
      <div className="container mt-5">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Manage School Session Mapping</h2>
          <Button variant="primary" onClick={() => handleShowModal()}>
            Add
          </Button>
        </div>

        <table className="table table-bordered table-striped">
        <thead className="thead-dark">	
            <tr>
              <th>#</th>
              <th>School Name</th>
              <th>Session</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {mappings.length > 0 ? (
              mappings.map((mapping, index) => (
                <tr key={mapping.mappingId}>
                  <td>{index + 1}</td>
                  <td>{mapping.schoolName}</td>
                  <td>{mapping.sessionName}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleShowModal(mapping)}
                    >
                      Edit
                    </Button>{" "}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDelete(mapping.mappingId)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center">
                  No mappings available.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Footer />
      <ToastContainer />

      {/* Bootstrap Modal for Add/Edit */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editMode ? "Edit Mapping" : "Add Mapping"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>School</Form.Label>
              <Form.Select
                name="schoolId"
                value={formData.schoolId}
                onChange={handleInputChange}
              >
                <option value="">Select School</option>
                {schools.map((school) => (
                  <option key={school.schoolId} value={school.schoolId}>
                    {school.schoolOrCollegeName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Session</Form.Label>
              <Form.Select
                name="sessionId"
                value={formData.sessionId}
                onChange={handleInputChange}
              >
                <option value="">Select Session</option>
                {sessions.map((session) => (
                  <option key={session.sessionId} value={session.sessionId}>
                    {session.sessionName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            {editMode ? "Update" : "Add"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default SchoolSessionMapping;
